import React from "react";

export interface IPrintProps {
    print: boolean;
}

export const PrintContext = React.createContext<IPrintProps>({ print: false });
